import { currenciesBySite, totalCurrencies } from './currenciesBySite';

const site = process.env.REACT_APP_BUILD_SITE;

export const formatAmount = (amount, currency, forceSymbol = false) => {
  let config;
  if (!currency) {
    const k = Object.keys(currenciesBySite[site])[0];
    config = currenciesBySite[site][k];
  } else {
    config = currenciesBySite[site][currency];
  }
  const { symbol, separator } = config;
  const formattedAmount = Math.trunc(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  return currency || forceSymbol ? `${symbol} ${formattedAmount}` : `${formattedAmount}`;
};

export const genericFormatAmount = (amount, currency) => {
  if (!amount) return 0;
  const symbol = totalCurrencies[currency];
  const separator = totalCurrencies.separators[site];
  const formattedAmount = Math.trunc(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  return `${symbol || ''} ${formattedAmount}`;
};

export const formatNumber = amount => {
  if (!amount) return 0;
  const separator = totalCurrencies.separators[site];
  const amountInteger = amount
    .toString()
    .replace('%', '')
    .split('.');
  if (separator === '.' && amount.toString().includes('.')) {
    amountInteger[0] = amountInteger[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    return amountInteger.join(',');
  }
  if (separator === ',' && amount.toString().includes('.')) {
    amountInteger[0] = amountInteger[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    return amountInteger.join('.');
  }
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

export const formatNumberCurrency = (amount, currency) => {
  if (!amount) return 0;
  const symbol = totalCurrencies[currency];
  const separator = totalCurrencies.separators[site];
  const amountInteger = amount.toString().split('.');
  if (separator === '.' && amount.toString().includes('.')) {
    amountInteger[0] = amountInteger[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    amountInteger[1] = amountInteger[1].padEnd(2, '0');
    return `${symbol || ''}${amountInteger.join(',')}`;
  }
  if (separator === ',' && amount.toString().includes('.')) {
    amountInteger[0] = amountInteger[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    amountInteger[1] = amountInteger[1].padEnd(2, '0');
    return `${symbol || ''}${amountInteger.join('.')}`;
  }
  return `${symbol || ''}${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)},00`;
};
